import { Typography } from '@mui/material';
import Decimal from 'decimal.js';
import { compact } from 'lodash';

import { SubtleLabelItem } from '@/components/display/SubtleLabelItem/SubtleLabelItem';
import { Card } from '@/components/layout/Card/Card';
import { SidePanel } from '@/components/modals/SidePanel';
import { DispositiveProvisionsListView } from '@/modules/dispositiveProvisions/DispositiveProvisionsListView/DispositiveProvisionsListView';
import { HypotheticalTransfersCard } from '@/modules/entities/details/HypotheticalTransfersCard/HypotheticalTransfersCard';

import { OrganizationSummaryPanel_OrganizationFragment } from './graphql/OrganizationSummaryPanel.generated';
import { ClientOrganizationTabs } from './OrganizationSummaryPanel.types';
import { getSummaryFields } from './OrganizationSummaryPanel.utils';

interface UseClientOrganziationPanelsInput {
  summaryFields: ReturnType<typeof getSummaryFields>;
  currentNodeValue?: Decimal;
  organization?: OrganizationSummaryPanel_OrganizationFragment;
  isOnSingleEntityDiagram?: boolean;
}

export function useClientOrganizationPanels({
  summaryFields,
  currentNodeValue,
  organization,
  isOnSingleEntityDiagram,
}: UseClientOrganziationPanelsInput) {
  return compact([
    {
      name: 'Summary',
      value: ClientOrganizationTabs.Summary,
      component: (
        <>
          <SubtleLabelItem
            label="Type of organization"
            value={summaryFields.kind}
          />
          <SubtleLabelItem label="Location" value={summaryFields.location} />
          <Card variant="filled" sx={{ p: 2 }}>
            <SidePanel.Section>
              <Typography variant="title-l" component="h3" mb={1}>
                Point of contact
              </Typography>
              <SubtleLabelItem label="Name" value={summaryFields.pocName} />
              <SubtleLabelItem label="Email" value={summaryFields.pocPhone} />
              <SubtleLabelItem label="Phone" value={summaryFields.pocEmail} />
            </SidePanel.Section>
          </Card>
        </>
      ),
    },
    !isOnSingleEntityDiagram && {
      name: 'Dispositions',
      value: ClientOrganizationTabs.Disposition,
      component: (
        <DispositiveProvisionsListView currentNodeValue={currentNodeValue} />
      ),
    },
    !isOnSingleEntityDiagram && {
      name: 'Hypothetical transfers',
      value: ClientOrganizationTabs.Transfers,
      component: <HypotheticalTransfersCard organization={organization} />,
    },
  ]);
}
